import { createContext, useContext } from "react";
import { useParams } from "react-router";
import MapfreLogo from "src/assets/icons/mapfre_logo.png";
import { Spinner } from "src/components/shared";
import { useCheckout } from "src/hooks/api";
import ApiErrorPage from "src/pages/ApiErrorPage";
import ExpiredLinkPage from "src/pages/ExpiredLinkPage";
import { mockData } from "src/utils/mockData";

const SharedDataContext = createContext<CheckoutType | undefined>(undefined);
const isUseMockData = false;

export const useCheckoutDataContext = () => {
  const context = useContext(SharedDataContext);
  if (!context) {
    throw new Error("Error in loading the context");
  }
  return context;
};

export const SharedDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const params = useParams<OrderSubscriptionParamsType>();
  const token = params.token as string;

  const { data, isLoading, error, showError } = useCheckout(token);
  const providerData = mockData(data, { isUseMockData });

  if (isLoading)
    return (
      <main className="flex min-h-screen w-full items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center gap-4">
          <img src={MapfreLogo} alt="Mapfre" />
          <Spinner />
        </div>
      </main>
    );

  if (error) return <ApiErrorPage errorMessage={error} showError={showError} />;

  // Link expirado: a API responde 200 com `available: false` e payload reduzido
  // (sem status/pedido). Renderizar o checkout com esses dados quebraria as
  // páginas, então mostramos a página de link expirado.
  if (providerData?.available === false) return <ExpiredLinkPage />;

  return (
    <SharedDataContext.Provider value={providerData}>
      {children}
    </SharedDataContext.Provider>
  );
};
